import {Badge} from '@kroll-resolver-crisp/ui-components-react';
import {type Submission} from '@/api/submissions';
import {statusLabel, statusTone, toneBadge} from '@/lib/status';

// The single "what state is this submission in" indicator - the table row and the detail drawer's
// header both use it, so a row and its own drawer never disagree about which colour a status is.
export function SubmissionStatusPill({status}: {readonly status: Submission['action_status']}) {
  return <Badge {...toneBadge(statusTone(status))}>{statusLabel(status)}</Badge>;
}
